export default "__VITE_ASSET__BMpzPzOB__"